export default "__VITE_ASSET__CYxFSjFq__"